<!-- EchartsDoughnutPieChart.vue -->
<!-- 正常的圆环图 -->
<template>
  <div class="pie-chart-container">
    <div ref="chart" :style="{ width: width, height: height }"></div>
  </div>
</template>

<script>
import * as echarts from 'echarts';

export default {
  name: 'EchartsDoughnutPieChart',
  props: {
    // 图表数据
    chartData: {
      type: Array,
      default: () => [
        { value: 25, name: '故障次数' },
        { value: 735, name: '正常次数' }
      ]
    },
    // 图表标题
    title: {
      type: String,
      default: '故障率',
      
    },
    // 系列名称
    seriesName: {
      type: String,
      default: '数据统计'
    },
    // 半径范围
    radius: {
      type: Array,
      default: () => ['40%', '70%']
    },
    // 图例位置
    legendPosition: {
      type: String,
      default: 'bottom',
      validator: (value) => {
        return ['top', 'bottom', 'left', 'right', 'top-left', 'top-right', 'bottom-left', 'bottom-right', 'none'].includes(value);
      }
    },
    // 是否显示图例
    showLegend: {
      type: Boolean,
      default: true
    },
    // 图例方向
    legendOrient: {
      type: String,
      default: 'horizontal',
      validator: (value) => {
        return ['horizontal', 'vertical'].includes(value);
      }
    },
    // 图例与饼图的间距
    legendGap: {
      type: [Number, String],
      default: 10
    },
    // 标题与饼图的间距
    titleGap: {
      type: [Number, String],
      default: 20
    },
    // 尺寸配置
    width: {
      type: String,
      default: '100%'
    },
    height: {
      type: String,
      default: '400px'
    },
    // 下载相关属性
    downloadFileName: {
      type: String,
      default: 'pie_chart'
    },
    downloadType: {
      type: String,
      default: 'png',
      validator: (value) => ['png', 'jpeg'].includes(value)
    },
    // 是否显示工具箱
    showToolbox: {
      type: Boolean,
      default: true
    },
    // 新增：颜色序列配置
    colors: {
      type: Array,
      default: () => [
        '#5470c6', '#91cc75', '#fac858', '#ee6666', 
        '#73c0de', '#3ba272', '#fc8452', '#9a60b4',
        '#ea7ccc', '#7ebf42', '#e6d450', '#f2a7c3',
        '#b6a2de', '#5ab1ef', '#ffb980', '#d87a80'
      ]
    },
    // 新增：图例文本颜色
    legendTextColor: {
      type: String,
      default: '#333'
    },
    // 新增：图例标记大小
    legendItemWidth: {
      type: Number,
      default: 12
    },
    legendItemHeight: {
      type: Number,
      default: 12
    },
    // 新增：是否在饼图数据中优先使用自定义颜色
    useDataColorPriority: {
      type: Boolean,
      default: true
    },
    // 标签显示相关配置
    // 是否显示饼图标签
    showLabel: {
      type: Boolean,
      default: true
    },
    // 标签位置
    labelPosition: {
      type: String,
      default: 'outside',
      validator: (value) => ['inside', 'outside', 'center'].includes(value)
    },
    // 标签内容格式
    labelFormatter: {
      type: [String, Function],
      default: '{b}: {c} ({d}%)'
    },
    // 标签字体大小
    labelFontSize: {
      type: Number,
      default: 14
    },
    // 标签字体颜色
    labelColor: {
      type: String,
      default: '#333'
    },
    // 标签是否显示引导线
    showLabelLine: {
      type: Boolean,
      default: true
    },
    // 引导线长度
    labelLineLength: {
      type: Number,
      default: 15
    },
    // 引导线长度2（弯曲部分）
    labelLineLength2: {
      type: Number,
      default: 15
    },
    // 引导线颜色
    labelLineColor: {
      type: String,
      default: '#aaa'
    },
    // 引导线样式
    labelLineStyle: {
      type: Object,
      default: () => ({
        type: 'solid',
        width: 1
      })
    },
    // 内部标签相关配置
    // 内部标签是否显示在饼图内部
    insideLabelShow: {
      type: Boolean,
      default: false
    },
    // 内部标签位置
    insideLabelPosition: {
      type: String,
      default: 'center',
      validator: (value) => ['top', 'left', 'right', 'bottom', 'center'].includes(value)
    },
    // 内部标签格式
    insideLabelFormatter: {
      type: [String, Function],
      default: '{d}%'
    },
    // 内部标签字体大小
    insideLabelFontSize: {
      type: Number,
      default: 18
    },
    // 内部标签字体颜色
    insideLabelColor: {
      type: String,
      default: '#333'
    },
    // 内部标签字体粗细
    insideLabelFontWeight: {
      type: String,
      default: 'bold',
      validator: (value) => ['normal', 'bold', 'bolder', 'lighter'].includes(value)
    },
    // 是否显示内部总计标签
    showTotalLabel: {
      type: Boolean,
      default: false
    },
    // 总计标签内容
    totalLabelContent: {
      type: String,
      default: '总计'
    },
    // 总计标签格式
    totalLabelFormatter: {
      type: Function,
      default: function(dataArray) {
        const total = dataArray.reduce((sum, item) => sum + item.value, 0);
        return `总计\n${total}`;
      }
    },
    // 新增：图例数据相关配置
    // 是否在图例中显示数据
    showLegendData: {
      type: Boolean,
      default: false
    },
    // 图例数据格式
    legendDataFormatter: {
      type: [String, Function],
      default: '{name}: {value}'
    }
  },
  data() {
    return {
      chart: null
    };
  },
  mounted() {
    this.$nextTick(() => {
      this.initChart();
    });
  },
  beforeDestroy() {
    if (this.chart) {
      this.chart.dispose();
      this.chart = null;
    }
    window.removeEventListener('resize', this.handleResize);
  },
  watch: {
    chartData: {
      handler(newVal) {
        console.log('chartData changed:', newVal);
        this.$nextTick(() => {
          this.updateChart();
        });
      },
      deep: true
    },
    legendPosition: {
      handler() {
        this.updateChart();
      }
    },
    showLegend: {
      handler() {
        this.updateChart();
      }
    },
    legendOrient: {
      handler() {
        this.updateChart();
      }
    },
    legendGap: {
      handler() {
        this.updateChart();
      }
    },
    titleGap: {
      handler() {
        this.updateChart();
      }
    },
    width: {
      handler() {
        this.handleResize();
      }
    },
    height: {
      handler() {
        this.handleResize();
      }
    },
    showToolbox: {
      handler() {
        this.updateChart();
      }
    },
    // 新增：颜色相关属性的监听
    colors: {
      handler() {
        this.updateChart();
      },
      deep: true
    },
    legendTextColor: {
      handler() {
        this.updateChart();
      }
    },
    // 标签相关属性的监听
    showLabel: {
      handler() {
        this.updateChart();
      }
    },
    labelPosition: {
      handler() {
        this.updateChart();
      }
    },
    labelFormatter: {
      handler() {
        this.updateChart();
      }
    },
    labelFontSize: {
      handler() {
        this.updateChart();
      }
    },
    labelColor: {
      handler() {
        this.updateChart();
      }
    },
    showLabelLine: {
      handler() {
        this.updateChart();
      }
    },
    labelLineLength: {
      handler() {
        this.updateChart();
      }
    },
    labelLineLength2: {
      handler() {
        this.updateChart();
      }
    },
    labelLineColor: {
      handler() {
        this.updateChart();
      }
    },
    insideLabelShow: {
      handler() {
        this.updateChart();
      }
    },
    insideLabelPosition: {
      handler() {
        this.updateChart();
      }
    },
    insideLabelFontSize: {
      handler() {
        this.updateChart();
      }
    },
    insideLabelColor: {
      handler() {
        this.updateChart();
      }
    },
    insideLabelFontWeight: {
      handler() {
        this.updateChart();
      }
    },
    showTotalLabel: {
      handler() {
        this.updateChart();
      }
    },
    // 新增：图例数据相关属性的监听
    showLegendData: {
      handler() {
        this.updateChart();
      }
    },
    legendDataFormatter: {
      handler() {
        this.updateChart();
      }
    }
  },
  methods: {
    // 计算百分比
    calculatePercent(value) {
      if (!this.chartData || !Array.isArray(this.chartData)) return '0';
      const total = this.chartData.reduce((sum, item) => sum + item.value, 0);
      if (total === 0) return '0';
      return ((value / total) * 100).toFixed(1);
    },
    
    // 下载图片功能
    downloadImage() {
      if (!this.chart) {
        console.warn('图表实例未初始化');
        return false;
      }

      try {
        const dataURL = this.chart.getDataURL({
          type: this.downloadType,
          pixelRatio: 2,
          backgroundColor: '#ffffff',
          excludeComponents: ['toolbox']
        });

        const link = document.createElement('a');
        link.href = dataURL;
        link.download = `${this.downloadFileName}_${new Date().getTime()}.${this.downloadType}`;
        
        document.body.appendChild(link);
        link.click();
        document.body.removeChild(link);
        
        console.log('图表下载成功');
        return true;
      } catch (error) {
        console.error('图表下载失败:', error);
        alert('下载失败，请重试');
        return false;
      }
    },

    // 获取工具箱配置
    getToolboxConfig() {
      if (!this.showToolbox) {
        return undefined;
      }
      
      return {
        feature: {
          saveAsImage: {
            title: '保存为图片',
            type: this.downloadType,
            name: this.downloadFileName,
            pixelRatio: 2,
            backgroundColor: '#ffffff',
            excludeComponents: ['toolbox'],
          }
        },
        right: 10,
        top: 10,
        iconStyle: {
          borderColor: '#666'
        }
      };
    },

    initChart() {
      try {
        console.log('初始化饼图，容器:', this.$refs.chart);
        
        if (!this.$refs.chart) {
          console.error('图表容器未找到');
          return;
        }

        const container = this.$refs.chart;
        console.log('容器尺寸:', container.offsetWidth, 'x', container.offsetHeight);

        if (container.offsetWidth === 0 || container.offsetHeight === 0) {
          console.warn('图表容器尺寸为0，延迟初始化');
          setTimeout(() => this.initChart(), 100);
          return;
        }

        this.chart = echarts.init(this.$refs.chart);
        console.log('ECharts实例创建成功');
        
        this.updateChart();
        window.addEventListener('resize', this.handleResize);
        
      } catch (error) {
        console.error('初始化图表失败:', error);
      }
    },

    // 获取图例配置
    getLegendConfig() {
      if (!this.showLegend) {
        return { show: false };
      }

      const baseConfig = {
        orient: this.legendOrient,
        textStyle: {
          fontSize: 14,
          color: this.legendTextColor
        },
        itemGap: 10,
        itemWidth: this.legendItemWidth,
        itemHeight: this.legendItemHeight,
        show: true,
        selectedMode: true
      };

      // 如果启用了图例数据显示
      if (this.showLegendData) {
        baseConfig.formatter = (name) => {
          // 查找对应的数据项
          const dataItem = this.chartData.find(item => item.name === name);
          if (!dataItem) return name;

          // 如果是字符串模板
          if (typeof this.legendDataFormatter === 'string') {
            return this.legendDataFormatter
              .replace('{name}', name)
              .replace('{value}', dataItem.value)
              .replace('{percent}', this.calculatePercent(dataItem.value));
          }
          
          // 如果是函数
          if (typeof this.legendDataFormatter === 'function') {
            return this.legendDataFormatter(name, dataItem.value, this.calculatePercent(dataItem.value));
          }
          
          // 默认格式
          return `${name}: ${dataItem.value}`;
        };
      }

      const gapValue = this.getGapValue(this.legendGap);

      switch (this.legendPosition) {
        case 'top':
          return {
            ...baseConfig,
            top: gapValue,
            left: 'center'
          };
        case 'bottom':
          return {
            ...baseConfig,
            bottom: gapValue,
            left: 'center'
          };
        case 'left':
          return {
            ...baseConfig,
            left: gapValue,
            top: 'center',
            orient: 'vertical'
          };
        case 'right':
          return {
            ...baseConfig,
            right: gapValue,
            top: 'center',
            orient: 'vertical'
          };
        case 'top-left':
          return {
            ...baseConfig,
            top: gapValue,
            left: gapValue
          };
        case 'top-right':
          return {
            ...baseConfig,
            top: gapValue,
            right: gapValue
          };
        case 'bottom-left':
          return {
            ...baseConfig,
            bottom: gapValue,
            left: gapValue
          };
        case 'bottom-right':
          return {
            ...baseConfig,
            bottom: gapValue,
            right: gapValue
          };
        case 'none':
          return { show: false };
        default:
          return {
            ...baseConfig,
            bottom: gapValue,
            left: 'center'
          };
      }
    },

    // 获取标题配置
    getTitleConfig() {
      const titleGap = this.getGapValue(this.titleGap);
      
      return {
        text: this.title,
        top: titleGap,
        left: 'center',
        textStyle: {
          fontSize: 18,
          fontWeight: 'bold',
          color: '#666'
        }
      };
    },

    // 获取饼图中心位置配置
    getPieCenter() {
      if (!this.showLegend || this.legendPosition === 'none') {
        return ['50%', '52%'];
      }

      switch (this.legendPosition) {
        case 'top':
          return ['50%', '60%'];
        case 'bottom':
          if (this.height.includes('150px') || this.height.includes('200px')){
            return ['50%', '40%'];
          }
          return ['50%', '45%'];
        case 'left':
          return ['60%', '50%'];
        case 'right':
          return ['40%', '50%'];
        case 'top-left':
          return ['55%', '60%'];
        case 'top-right':
          return ['45%', '60%'];
        case 'bottom-left':
          return ['55%', '45%'];
        case 'bottom-right':
          return ['45%', '45%'];
        default:
          return ['50%', '50%'];
      }
    },

    // 辅助方法：将数值转换为带单位的字符串
    getGapValue(gap) {
      if (typeof gap === 'number') {
        return gap + 'px';
      }
      return gap;
    },

    // 准备图表数据，应用颜色
    prepareChartData(data) {
      return data.map((item, index) => {
        const dataItem = {
          value: item.value,
          name: item.name
        };
        
        // 确定使用哪种颜色
        let finalColor = null;
        
        // 优先使用数据中的颜色（如果启用优先级）
        if (this.useDataColorPriority && item.color) {
          finalColor = item.color;
        }
        // 否则使用颜色序列中的颜色
        else if (this.colors && this.colors.length > 0) {
          finalColor = this.colors[index % this.colors.length];
        }
        
        // 如果数据中有颜色但优先级未启用，也使用数据中的颜色
        if (!finalColor && item.color) {
          finalColor = item.color;
        }
        
        // 如果有确定的颜色，设置itemStyle
        if (finalColor) {
          dataItem.itemStyle = {
            color: finalColor
          };
          
          // 设置高亮状态的颜色
          dataItem.emphasis = {
            itemStyle: {
              shadowBlur: 10,
              shadowOffsetX: 0,
              shadowColor: 'rgba(0, 0, 0, 0.5)',
              color: this.lightenColor(finalColor, 20) // 高亮时变亮
            }
          };
        }
        
        return dataItem;
      });
    },

    // 工具方法：调整颜色亮度
    lightenColor(color, percent) {
      if (!color || !color.startsWith('#')) return color;
      
      const num = parseInt(color.slice(1), 16);
      const amt = Math.round(2.55 * percent);
      
      const R = (num >> 16) + amt;
      const G = (num >> 8 & 0x00FF) + amt;
      const B = (num & 0x0000FF) + amt;
      
      return `#${(
        0x1000000 +
        (R < 255 ? R < 1 ? 0 : R : 255) * 0x10000 +
        (G < 255 ? G < 1 ? 0 : G : 255) * 0x100 +
        (B < 255 ? B < 1 ? 0 : B : 255)
      )
        .toString(16)
        .slice(1)}`;
    },

    // 获取标签配置
    getLabelConfig() {
      if (!this.showLabel) {
        return {
          show: false
        };
      }

      const baseConfig = {
        show: true,
        formatter: this.labelFormatter,
        fontSize: this.labelFontSize,
        color: this.labelColor
      };

      // 根据标签位置设置不同的配置
      switch (this.labelPosition) {
        case 'inside':
          return {
            ...baseConfig,
            position: 'inside',
            formatter: this.insideLabelShow ? this.insideLabelFormatter : baseConfig.formatter,
            fontSize: this.insideLabelShow ? this.insideLabelFontSize : baseConfig.fontSize,
            color: this.insideLabelShow ? this.insideLabelColor : baseConfig.color,
            fontWeight: this.insideLabelShow ? this.insideLabelFontWeight : 'normal'
          };
        case 'outside':
          return {
            ...baseConfig,
            position: 'outside'
          };
        case 'center':
          // 中心标签通常用于显示总计
          if (this.showTotalLabel) {
            return {
              show: false, // 外部标签不显示
              position: 'center',
              formatter: this.totalLabelFormatter
            };
          }
          return {
            ...baseConfig,
            position: 'center'
          };
        default:
          return {
            ...baseConfig,
            position: 'outside'
          };
      }
    },

    // 获取标签线配置
    getLabelLineConfig() {
      if (!this.showLabelLine || this.labelPosition === 'inside' || this.labelPosition === 'center') {
        return {
          show: false
        };
      }

      return {
        show: true,
        length: this.labelLineLength,
        length2: this.labelLineLength2,
        lineStyle: {
          color: this.labelLineColor,
          type: this.labelLineStyle.type,
          width: this.labelLineStyle.width
        }
      };
    },

    // 获取饼图系列配置
    getPieSeriesConfig(data) {
      const seriesConfig = {
        name: this.seriesName,
        type: 'pie',
        radius: this.radius,
        center: this.getPieCenter(),
        avoidLabelOverlap: true,
        label: this.getLabelConfig(),
        labelLine: this.getLabelLineConfig(),
        emphasis: {
          label: {
            show: true,
            fontSize: Math.min(this.labelFontSize + 2, 20),
            fontWeight: 'bold'
          },
          scale: true,
          scaleSize: 5
        },
        data: data,
        itemStyle: {
          borderColor: '#fff',
          borderWidth: 2
        },
        selectedMode: 'single',
        selectedOffset: 10
      };

      // 如果是中心标签且显示总计，添加额外的标签配置
      if (this.labelPosition === 'center' && this.showTotalLabel) {
        seriesConfig.label = {
          ...seriesConfig.label,
          show: true,
          position: 'center',
          formatter: () => {
            if (typeof this.totalLabelFormatter === 'function') {
              return this.totalLabelFormatter(this.chartData);
            }
            return this.totalLabelContent;
          },
          fontSize: this.insideLabelFontSize,
          color: this.insideLabelColor,
          fontWeight: this.insideLabelFontWeight
        };

        // 同时关闭外部标签
        seriesConfig.labelLine.show = false;
      }

      return seriesConfig;
    },

    updateChart() {
      if (!this.chart) {
        console.warn('图表实例未创建，尝试重新初始化');
        this.initChart();
        return;
      }

      if (!this.chartData || !Array.isArray(this.chartData) || this.chartData.length === 0) {
        console.warn('图表数据为空或无效:', this.chartData);
        const defaultData = [
          { value: 50, name: '默认数据A' },
          { value: 50, name: '默认数据B' }
        ];
        this.renderChart(defaultData);
        return;
      }

      this.renderChart(this.chartData);
    },

    renderChart(data) {
      try {
        // 准备带有颜色的数据
        const preparedData = this.prepareChartData(data);
        
        const option = {
          // 设置全局颜色序列 - 这会影响图例标记颜色
          color: this.colors,
          toolbox: this.getToolboxConfig(),
          tooltip: {
            trigger: 'item',
            formatter: (params) => {
              const percent = params.percent;
              const value = params.value;
              const name = params.name;
              const color = params.color;
              
              // 添加颜色块到tooltip
              return `
                <div style="display: flex; align-items: center;">
                  <div style="width: 12px; height: 12px; background: ${color}; margin-right: 8px; border-radius: 2px;"></div>
                  <div>
                    <strong>${name}</strong><br/>
                    数值: ${value}<br/>
                    占比: ${percent}%
                  </div>
                </div>
              `;
            }
          },
          legend: this.getLegendConfig(),
          title: this.getTitleConfig(),
          series: [
            this.getPieSeriesConfig(preparedData)
          ]
        };

        // console.log('设置图表选项，数据长度:', data.length);
        // console.log('使用的颜色序列:', this.colors);
        // console.log('标签配置:', this.getLabelConfig());
        this.chart.setOption(option, true);
        // console.log('图表渲染完成');
        
      } catch (error) {
        console.error('渲染图表失败:', error);
      }
    },

    handleResize() {
      if (this.chart) {
        try {
          this.chart.resize();
        } catch (error) {
          console.error('调整图表大小失败:', error);
        }
      }
    },

    resize() {
      this.handleResize();
    },

    // 新增：手动设置饼图中心位置的方法
    setPieCenter(x, y) {
      if (this.chart) {
        const option = this.chart.getOption();
        if (option.series && option.series[0]) {
          option.series[0].center = [x, y];
          this.chart.setOption(option);
        }
      }
    },

    // 新增：手动设置标题位置的方法
    setTitlePosition(top) {
      if (this.chart) {
        const option = this.chart.getOption();
        if (option.title) {
          option.title.top = this.getGapValue(top);
          this.chart.setOption(option);
        }
      }
    },
    
    // 新增：获取图表实例
    getInstance() {
      return this.chart;
    },
    
    // 新增：手动设置颜色
    setColors(colors) {
      if (colors && Array.isArray(colors)) {
        // 更新图表选项中的颜色
        if (this.chart) {
          const option = this.chart.getOption();
          option.color = colors;
          this.chart.setOption(option);
        }
      }
    },

    // 新增：设置标签显示状态
    setLabelShow(show) {
      if (this.chart) {
        const option = this.chart.getOption();
        if (option.series && option.series[0]) {
          option.series[0].label.show = show;
          this.chart.setOption(option);
        }
      }
    },

    // 新增：设置标签位置
    setLabelPosition(position) {
      if (this.chart && ['inside', 'outside', 'center'].includes(position)) {
        const option = this.chart.getOption();
        if (option.series && option.series[0]) {
          option.series[0].label.position = position;
          // 根据位置调整标签线
          if (position === 'inside' || position === 'center') {
            option.series[0].labelLine.show = false;
          } else {
            option.series[0].labelLine.show = this.showLabelLine;
          }
          this.chart.setOption(option);
        }
      }
    },

    // 新增：设置标签格式
    setLabelFormatter(formatter) {
      if (this.chart) {
        const option = this.chart.getOption();
        if (option.series && option.series[0]) {
          option.series[0].label.formatter = formatter;
          this.chart.setOption(option);
        }
      }
    }
  },
  
  // 暴露方法给父组件
  expose: [
    'downloadImage', 
    'resize', 
    'setPieCenter', 
    'setTitlePosition', 
    'getInstance', 
    'setColors',
    'setLabelShow',
    'setLabelPosition',
    'setLabelFormatter'
  ]
};
</script>

<style scoped>
.pie-chart-container {
  width: 100%;
  height: 100%;
  position: relative;
}
</style>